import React, { useState, useEffect } from 'react';
import styles from './MachineFirmwareTab.module.css';

import Api from 'utils/api';

const MachineFirmwareTab = () => {
  const [firmwares, setFirmwares] = useState([]);
  const [loading, setLoading] = useState(true);

  // 모달 및 폼 상태
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({ machineFirmwareId: null, machineFirmwareName: '' });

  useEffect(() => {
    fetchFirmwareList();
  }, []);

  // 1. 리스트 조회 (GET)
  const fetchFirmwareList = async () => {
    setLoading(true);
    const data = await Api.get('/machine/firmware');
    if (data?.machineFirmwareList) {
      setFirmwares(data.machineFirmwareList)
    } else {
      setFirmwares([]);
    }
    setLoading(false);
  };

  const handleOpenModal = (mode, data = null) => {
    setIsEditMode(mode === 'edit');
    setFormData(data ? { ...data } : { machineFirmwareId: null, machineFirmwareName: '' });
    setIsModalOpen(true);
  };

  // 2. 저장 로직 (POST)
  // 2. 저장 로직 (POST / PUT)
  const handleSave = async () => {
    if (!formData.machineFirmwareName.trim()) {
      return alert("펌웨어 이름을 입력해주세요.");
    }

    try {
      let response;

      if (isEditMode) {
        const requestBody = {
          machineFirmwareId: formData.machineFirmwareId,
          machineFirmwareName: formData.machineFirmwareName,
        };

        response = await Api.patch('/machine/firmware', requestBody);
      } else {
        const requestBody = {
          machineFirmwareName: formData.machineFirmwareName,
        };

        response = await Api.post('/machine/firmware', requestBody);
      }

      if (!response) return;

      alert(isEditMode ? "수정이 완료되었습니다." : "등록이 완료되었습니다.");
      setIsModalOpen(false);
      fetchFirmwareList();

    } catch (error) {
      console.error("통신 오류:", error);
      alert("서버와 통신 중 오류가 발생했습니다.");
    }
  };

  // 3. 삭제 로직 (DELETE)
  const handleDelete = async (id) => {
    if (!window.confirm("이 펌웨어를 삭제하시겠습니까?")) return;
    const data = await Api.delete(`/machine/firmware?machineFirmwareId=${id}`)

    if (data.code === 200) {
      alert("삭제가 완료되었습니다.");
      fetchFirmwareList(); // 삭제 후 목록 최신화
    } else {
      alert(`삭제 실패: ${data.message || '오류가 발생했습니다.'}`);
    }

  };

  if (loading) return <div className={styles.centerMsg}>펌웨어 정보를 불러오는 중...</div>;

  return (
    <div className={styles.container}>
      <div className={styles.topBar}>
        <div className={styles.countInfo}>등록된 펌웨어 <span className={styles.countNumber}>{firmwares.length}</span></div>
        <button className={styles.addBtn} onClick={() => handleOpenModal('add')}>+ 펌웨어 등록</button>
      </div>

      <div className={styles.cardGrid}>
        {firmwares.map((f) => (
          <div key={f.machineFirmwareId} className={styles.firmwareCard}>
            <div className={styles.cardHeader}>
              <div>
                <h3 className={styles.firmwareName}>{f.machineFirmwareName}</h3>
              </div>
            </div>

            <div className={styles.cardFooter}>
              <button className={styles.editBtn} onClick={() => handleOpenModal('edit', f)}>수정</button>
              <button className={styles.deleteBtn} onClick={() => handleDelete(f.machineFirmwareId)}>삭제</button>
            </div>
          </div>
        ))}
      </div>

      {isModalOpen && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <div className={styles.modalHeader}>
              <h3>{isEditMode ? '펌웨어 수정' : '새 펌웨어 등록'}</h3>
              <button className={styles.closeBtn} onClick={() => setIsModalOpen(false)}>✕</button>
            </div>
            <div className={styles.modalBody}>
              <div className={styles.formContainer}>
                <div className={styles.inputGroup}>
                  <label>펌웨어 명칭(버전)</label>
                  <input
                    name="machineFirmwareName"
                    value={formData.machineFirmwareName}
                    onChange={(e) => setFormData({ ...formData, machineFirmwareName: e.target.value })}
                    className={styles.modalInput}
                    placeholder="예: 1.0.2"
                    autoFocus
                  />
                </div>
              </div>
            </div>
            <div className={styles.modalFooter}>
              <button className={styles.cancelBtn} onClick={() => setIsModalOpen(false)}>취소</button>
              <button className={styles.saveBtn} onClick={handleSave}>저장하기</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MachineFirmwareTab;